import { Monitor, Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useThemeMode } from "@/hooks/use-theme-mode";
import type { ThemeMode } from "@/lib/theme-mode";

export const THEME_MODE_OPTIONS: {
	mode: ThemeMode;
	labelKey: string;
	Icon: typeof Sun;
}[] = [
	{ mode: "light", labelKey: "settings.themeLight", Icon: Sun },
	{ mode: "dark", labelKey: "settings.themeDark", Icon: Moon },
	{ mode: "system", labelKey: "settings.themeSystem", Icon: Monitor },
];

/** Light, dark or system. The choice applies at once and stays after reload. */
export function ThemeModeSwitcher(): React.JSX.Element {
	const { t } = useTranslation();
	const { mode, setMode } = useThemeMode();

	return (
		<fieldset
			aria-label={t("settings.appearance")}
			className="m-0 inline-flex min-w-0 gap-1 rounded-lg border border-dashboard-border bg-dashboard-surface p-1"
		>
			{THEME_MODE_OPTIONS.map(({ mode: option, labelKey, Icon }) => {
				const selected = mode === option;
				return (
					<button
						key={option}
						type="button"
						aria-pressed={selected}
						onClick={() => setMode(option)}
						className={
							selected
								? "inline-flex items-center gap-1.5 rounded-md bg-dashboard-paper px-3 py-1.5 text-sm font-semibold text-dashboard-text shadow-[var(--dashboard-shadow-secondary)]"
								: "inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium text-dashboard-muted hover:text-dashboard-text"
						}
					>
						<Icon className="h-4 w-4" />
						{t(labelKey)}
					</button>
				);
			})}
		</fieldset>
	);
}
